import styled from '@emotion/styled';
import { colors } from 'theme/colors';

export const StyledSearchWrapper = styled.div`
  background-color: ${colors.gray50};
  border: 1px solid ${colors.gray100};
  border-radius: 4px;
  padding: 20px;
`;
